<div class="stockLevelContainer">
	<cdx-svg-icon [fill]="iconFill" [name]="iconName" [size]="iconSize"></cdx-svg-icon>
	<div [ngClass]="infoColor" class="stock-level-label">{{ stockLevelName | sentencecase }}</div>
</div>
<p class="storeName" *ngIf="storeName">
	{{ storeName }}
</p>
<p class="storeAddress" *ngIf="storeAddress">
	{{ storeAddress }}
</p>
